import { render, staticRenderFns } from "./search-data.component.vue?vue&type=template&id=0ce35400&scoped=true"
import script from "./search-data.component.vue?vue&type=script&lang=ts"
export * from "./search-data.component.vue?vue&type=script&lang=ts"
import style0 from "./search-data.component.vue?vue&type=style&index=0&id=0ce35400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce35400",
  null
  
)

export default component.exports